import { UiControlConstants } from "./uicontrol-constants";
import eaeControlsModule from "../eaeControls.module";

export * from "./uicontrol-constants";

eaeControlsModule.constant("uiControlConstants", new UiControlConstants());
